// @flow

export type FileType = '*' | '.gif' | '.jpeg' | '.jpg' | '.m4v' | '.mov' | '.mp4' | '.png';

export const maxImageUploadSizeInMB = 15;
export const maxImageUploadSizeInBytes = maxImageUploadSizeInMB * 1024 * 1024;

// This is also defined in Features.VIDEO_UPLOAD.  Should we create a way to get feature properties?
export const maxVideoUploadSizeInBytes = 500 * 1024 * 1024;
